export * from "./MfAttrListCollapsible";
